export const IntegrationType = {
  livechat: "livechat",
  shoper: "shoper",
  channels: "channels",
  aws_marketplace: "aws_marketplace",
  phone_hq: "phone_hq"
};
